module.exports = __webpack_public_path__ + "static/media/sheet.4f9c41d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/builder/gameUniversity/sheet.png
// module id = 2302
// module chunks = 0